import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Header.css";

const navLinks = [
  { href: "#humanistic", label: "Mission", type: "scroll" },
  { href: "#solution", label: "Solution", type: "scroll" },
  { href: "#challenge", label: "Challenge", type: "scroll" },
  { href: "#impact", label: "Impact", type: "scroll" },
  { href: "#key-questions", label: "Whitepapers", type: "scroll" },
  { href: "/demo", label: "Demo", type: "route" },
];

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      const yOffset = id === "humanistic" ? -120 : -80;
      const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  const handleScrollOrNavigate = (
    e: React.MouseEvent<HTMLAnchorElement>,
    id: string
  ) => {
    e.preventDefault();
    setIsMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollToId: id } });
    } else {
      scrollToSection(id);
    }
  };

  const handleLogoClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollToId: "top" } });
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header className="header">
      <div className="container">
        <div className="logoTagline" onClick={handleLogoClick}>
          <img
            src="/silomedai-assets/images/silo-logo-default.png"
            alt="SILO Logo"
            className="logoImg"
          />
          <span className="tagline">
            Simulated Intelligence Learning Opportunities
          </span>
        </div>

        <nav className="navDesktop">
          {navLinks.map((link) =>
            link.type === "scroll" ? (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) =>
                  handleScrollOrNavigate(e, link.href.replace("#", ""))
                }
                className="scrollLink"
              >
                {link.label}
              </a>
            ) : (
              <Link key={link.href} to={link.href} className="link">
                {link.label}
              </Link>
            )
          )}
          <a
            href="#contact"
            onClick={(e) => handleScrollOrNavigate(e, "contact")}
            className="contactLink"
          >
            Contact Us
          </a>
        </nav>

        <button
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Open menu"
          className="hamburgerButton"
        >
          <span className="hamburgerSpan" />
          <span className="hamburgerSpan" />
          <span className="hamburgerSpan" />
        </button>
      </div>

      {isMenuOpen && (
        <nav className="mobileNav">
          {navLinks.map((link) =>
            link.type === "scroll" ? (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  handleScrollOrNavigate(e, link.href.replace("#", ""));
                }}
                className="mobileScrollLink"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setIsMenuOpen(false)}
                className="mobileLink"
              >
                {link.label}
              </Link>
            )
          )}
          <a
            href="#contact"
            onClick={(e) => {
              handleScrollOrNavigate(e, "contact");
            }}
            className="mobileContactLink"
          >
            Contact Us
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
